import { useCallback, useEffect, useState } from "react";

import brandService from "core/services/apiServices/brandService";

const useLandings = (brandId) => {

    const [ loading, setLoading ] = useState(false);

    const [ landings, setLandings ] = useState([]);

    const getLandings = useCallback( () => {
        setLoading(true);
        let params = {
            brandId
        };

        brandService.getLandings(params).
            then(data => {                
                setLandings(data);
            }).
            finally(() => {
                setLoading(false)
            })
    }, [brandId])

    const addLanding = useCallback( landing => {
        setLandings(prevState => ([
            landing,
            ...prevState
        ]))
    }, [brandId])

    const removeLanding = useCallback( id => {
        setLandings(prevState => (
            prevState.filter(l => l.id !== id)
        ))
    }, [brandId])

    const updateLanding = useCallback( landing => {
        setLandings(prevState => (
            prevState.map(l => l.id === landing.id ? landing : l)
        ))
    }, [brandId])

    useEffect(() => {
        if(brandId){
            getLandings()
        }
    }, [ brandId])


    return {
        loading,
        landings,
        getLandings,
        addLanding,
        removeLanding,
        updateLanding
    }
}

export default useLandings;